import { Box, Row, Text, Title } from '@factorialco/deprecated-design-system'
import { AvailableModules, Features } from 'generated/featureDefinitions'
import { useToggle } from 'usehooks-ts'

import FactorialTip from 'modules/core/components/FactorialTip'
import Upgrade, { UpgradeActions } from 'modules/core/components/Upgrade'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import { missingFeatureRequestReason } from 'modules/finance/lib/missingFeatureRequestReason'
import { UpsellingKit } from 'modules/upselling_kit/components'

interface Props {
  canGoToSettings: boolean
  hasFeature: boolean
}

const AccountingSection = ({ canGoToSettings, hasFeature }: Props) => {
  const { navigation } = useNavigation()
  const [upgradeModal, showUpgradeModal] = useToggle()
  const { company } = useCurrentSession()

  return (
    <>
      <Box flexGrow>
        <Row>
          <Row.Col halfWidth>
            <Title
              variant="400"
              title={i18n.t('expenses_v2.settings.accounting.title')}
              description={i18n.t('expenses_v2.settings.accounting.description')}
              illustration="money-spreadsheet"
            />
            {!hasFeature && (
              <Upgrade.Small
                title={i18n.t('expenses_v2.settings.accounting.upgrade_title')}
                action={{
                  type: UpgradeActions.contactCX,
                  onClick: () => showUpgradeModal(),
                }}
              />
            )}
          </Row.Col>
          <Row.Col halfWidth>
            <FactorialTip
              message={
                <Text size="300" weight="medium">
                  {i18n.t('expenses_v2.settings.accounting.tip_message')}
                </Text>
              }
              icon="tasks_management"
              routerTo={canGoToSettings ? navigation.settings.finance.accounting.fullPath() : ''}
              routerToText={i18n.t('expenses_v2.settings.accounting.link_text')}
            />
          </Row.Col>
        </Row>
      </Box>
      {upgradeModal && (
        <UpsellingKit.ProductModal
          isOpen={upgradeModal}
          onClose={showUpgradeModal}
          requestSource="Expenses settings page"
          featureRequested={Features.finance_ledger_accounts_core}
          moduleRequested={AvailableModules.expenses}
          requestReason={missingFeatureRequestReason(company)}
          pageSource="expenses_settings_accounting"
        />
      )}
    </>
  )
}

export default AccountingSection
